
export const publicRoutes = [
  "/",
  "/auth",
  "/student-auth",
  "/reset-password",
  "/pt",
  "/pt/",
  "/pt/auth",
  "/pt/student-auth",
  "/pt/reset-password",
  "/es",
  "/es/",
  "/es/auth",
  "/es/student-auth",
  "/es/reset-password",
  "/fr",
  "/fr/",
  "/fr/auth",
  "/fr/student-auth",
  "/fr/reset-password",
  "/privacy",
  "/terms",
  "/pt/privacy",
  "/pt/terms",
  "/es/privacy",
  "/es/terms",
  "/fr/privacy",
  "/fr/terms",
  "/features",
  "/benefits",
  "/pricing",
  "/testimonials",
  "/pt/features",
  "/pt/benefits",
  "/pt/pricing",
  "/pt/testimonials",
  "/es/features",
  "/es/benefits",
  "/es/pricing",
  "/es/testimonials",
  "/fr/features",
  "/fr/benefits",
  "/fr/pricing",
  "/fr/testimonials",
  "/complete-profile",
  "/pt/complete-profile",
  "/es/complete-profile",
  "/fr/complete-profile"
];
